'use strict';

import Vue from 'vue';
import { Settings } from 'luxon';

Settings.defaultZone = 'America/Chicago';

// import './controllers/product';
import './controllers/ensemble-widget';
import './controllers/booking-widget';
import './controllers/login-modal';
import './controllers/favorites-modal';
import './controllers/favorites-widget';
import './controllers/calendar';
import './controllers/package-group';
import './controllers/performance-list';
import './controllers/calendar-scroller';
import './controllers/promo-code-banner';
import './controllers/search';

if (window && !window.usePrototypeWidgets && document.getElementById('vue-widget')) {
    new Vue({ el: '#vue-widget' })
}
